import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IContractorReviewResponseInput } from 'libs/ebb-integration/src/lib/models/contractorreview.interface';
import { ContractorReviewApiService } from '../../data-services/contractorreview-api.service';
import { DialogContractorReviewResponseComponent, DialogContractorReviewResponseData } from './dialog-contractorreviewresponse.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'ebb-dialog-contractorreviews',
    templateUrl: './dialog-contractorreviews.component.html',
    standalone: false
})
export class DialogPortalContractorReviewsComponent implements OnInit {
  public showMore: boolean;
  public reviews: Array<{ id: string; toggle: boolean ;responseToggle:boolean}> =[];
  constructor(
    public dialogRef: MatDialogRef<DialogPortalContractorReviewsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogContractorReviewResponse: MatDialog,
    private readonly apiContractorReview: ContractorReviewApiService,
  ) { }

  ngOnInit() {
    this.showMore = false;
    this.data.reviews.forEach(x=>{
      var review = {id:x.id,toggle:false,responseToggle:false};
      this.reviews.push(review)
    })
  }

  onClose(): void {
    this.dialogRef.close(true);
  }

  onMore(): void {
    this.showMore = true;
  }
 public canShowResponse(data:any ,contractor:boolean):boolean {

if(data.response== null){
return false;

}
if(contractor ===true && data.response.length>0){
return true;

 }

 return false;

}

toggleCollapse(id): boolean {
  if(this.reviews.length>0){
    const  index = this.reviews.findIndex(x=>x.id==id);
 var value = this.reviews[index].toggle;
 

 return value}
 return false;
}
updateToggleCollapse(id) {
  if(this.reviews.length>0){
    const  index = this.reviews.findIndex(x=>x.id==id);
  //var value = this.reviews.filter(x=>x.id =id);
  this.reviews[index].toggle = !this.reviews[index].toggle;
  }
return false;
 }
 onResponse(id){
  const dialogContractorReviewResponseItem: DialogContractorReviewResponseData = {} as DialogContractorReviewResponseData;
  const  index = this.data.reviews.findIndex(x=>x.id==id);
  var review = this.data.reviews[index];
 

  dialogContractorReviewResponseItem.reviewId = id;
  dialogContractorReviewResponseItem.review = review.review;
  const dialogRef = this.dialogContractorReviewResponse.open(
    DialogContractorReviewResponseComponent,
    {
      width: '400px',
      maxWidth: '95vw',
      maxHeight: '95vh',
      data: dialogContractorReviewResponseItem
    }
  );

  dialogRef.afterClosed().subscribe(
    reviewData => {
      if (reviewData && reviewData.response.length > 0) {
        const contractorReviewResponseInput: IContractorReviewResponseInput = {} as IContractorReviewResponseInput;
        contractorReviewResponseInput.response = reviewData.response;
        var date = new Date;
        contractorReviewResponseInput.responseDate =date;
      
        this.apiContractorReview
          .saveContractorReviewResponse(contractorReviewResponseInput, id)
          .subscribe(
            data => { 
              this.data.reviews[index].response =reviewData.response;
              this.data.reviews[index].responseDate =date;
            },
            error => {
              console.warn(
                `performContractorReviewResponseDialogSteps error1: ${JSON.stringify(
                  error
                )}`
              );
            }
          );
      }
    },
    error => {
      console.warn(
        `performContractorReviewResponseDialogSteps error2: ${JSON.stringify(
          error
        )}`
      );
    }
  );
  return false;
 }
 
}
